import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconMinus = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M5 11h14v2H5z" }, void 0) }, void 0));
const Memo = memo(SvgIconMinus);
export default Memo;
//# sourceMappingURL=IconMinus.js.map